import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";

export default function SalesHome() {
    
    return (
        <>            
            <h1 className="dash-title">Sales </h1>

            <div className="row dash-row">
                <div className="col-md-4 col-sm-4 col-6">
                    <div className="addbox mb-4">
                        <h4>SECTORS</h4>
                        <p><Link to="/sales/sectors"><i className="fa fa-globe"></i></Link></p>
                    </div>
                </div>
                <div className="col-md-4 col-sm-4 col-6">
                    <div className="addbox mb-4">
                        <h4>CUSTOMERS</h4>
                        <p><Link to="/sales/customers"><i className="fa fa-lightbulb-o"></i></Link></p>
                    </div>
                </div>
                <div className="col-md-4 col-sm-4 col-6">
                    <div className="addbox mb-4">
                        <h4>CONTACTS</h4>
                        <p><Link to="/sales/contacts"><i className="fa fa-street-view"></i></Link></p>
                    </div>
                </div>
                <div className="col-md-4 col-sm-4 col-6">
                    <div className="addbox mb-4">
                        <h4>LEADS</h4>
                        <p><Link to="/sales/leads"><i className="fa fa-location-arrow"></i></Link></p>
                    </div>
                </div>
                <div className="col-md-4 col-sm-4 col-12">
                    <div className="addbox mb-4">
                        <h4>SALES CALLS</h4>
                        <p><Link to="/sales/calls"><i className="fa fa-phone"></i></Link></p>
                    </div>
                </div>
            </div>
        </>
    );
}
